import { AppBar, Toolbar,Typography,Button } from "@material-ui/core";
import React from "react";
import { Link as RouterLink } from "react-router-dom";


function HeaderInfluxs() {
    const headersData = [
        {
            label: "Accuiel",
            href: "/listContra",
        },
        // {
        //     label: "Message",
        //     href: "/message",
        // },
        {
            label: "Déconnexion",
            href: "/",
        }
    ];

    const getMenuButtons = () => {
        return headersData.map(({ label, href }) => {
            return (
                <Button
                    {...{
                        key: label,
                        color: "inherit",
                        to: href,
                        component: RouterLink,
                    }}
                >
                    {label}
                </Button>
            );
        });
    };
    const displayDesktop = () => {
        return <Toolbar className="toolbar">{influxLogo} {getMenuButtons()}</Toolbar>;
    };
    const influxLogo = (
        <Typography variant="h6" component="h1"className="logoType" >
            Influxs
        </Typography>
    );
    return (
        <header>
            <AppBar className="header">{displayDesktop()}</AppBar>
        </header>
    )
}

export default HeaderInfluxs;